import { Box, styled } from "@mui/material";
import ThemeButton from "components/Buttons/ThemeButton";

export const Container = styled("div")<{ scale: number }>`
	transform: scale(${(props) => props.scale});
	font-size: 10px;
	width: 34.3em;
	background-color: #fff;
	border-radius: 2.4em;
	position: relative;
	overflow: hidden;
`;

export const Header = styled("div")`
	height: 17.6em;
	position: relative;
`;

export const Background = styled("img")`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const Reward = styled("div")<{ "data-image": string; isPbv3?: boolean }>`
	width: 15.2em;
	height: 15.2em;
	background-color: ${(props) => (props.isPbv3 ? "#f8cb53" : "#7ae0db")};
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: calc(152px / 2.5);
	z-index: 1199;
	border: 4px solid #fff;
	border-radius: 11px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-image: url(${(props) => props["data-image"]});
	background-size: ${(props) => (props.isPbv3 ? "100%" : "200%")};
	background-repeat: no-repeat;
	background-position: ${(props) => (props.isPbv3 ? "center" : "50% 110%")};
`;

export const Icon = styled("div")`
	position: absolute;
	top: -1.5rem;
	right: -1rem;
`;

export const RewardImg = styled("img")`
	width: 100px;
	height: 100px;
	object-fit: contain;
`;

export const RewardText = styled(Box)`
	font-family: "Baloo";
	font-size: 35px;
	position: absolute;
	bottom: -3px;
	right: 10px;
	color: white;
	paint-order: stroke fill;
	filter: drop-shadow(1.1px 1.1px 0 #000);
	-webkit-text-stroke-width: 3.05px;
	-webkit-text-stroke-color: #000;
	display: flex;
	align-items: center;
`;

export const Body = styled("div")`
	padding: 6em 3em 2em;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
	margin: 0 auto;
`;

export const Title = styled("span")`
	font-family: "Inter";
	font-size: 1.6em;
	font-weight: 500;
	line-height: 1.25em;
	text-align: center;
	padding-bottom: 2em;
`;

export const Button = styled(ThemeButton)``;
